import { activateOnboardingStep, setOnboardingAnswers } from 'actions/assessment'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import DataPrivacySwitch from './DataPrivacySwitch'
import GenderPicker from './GenderPicker'
import PostCode from './PostCode'
import YearOfBirth from './YearOfBirth'

const Demographics = () => {
    const dispatch = useDispatch()

    const {
        appState: {
            onboardingAnswers: { postCode, genderIdentity, yearOfBirth },
        },
        database: {
            onboardingTemplate: { index },
        },
    } = useSelector(state => state.assessment)

    const [selectedCode, setSelectedCode] = useState(null)
    const [selectedGender, setSelectedGender] = useState(null)
    const [selectedYear, setSelectedYear] = useState(null)
    const [recoveryData, setRecoveryData] = useState({})
    const [checked, setChecked] = useState(false)

    useEffect(() => {
        if (checked) {
            setRecoveryData({ selectedCode, selectedGender, selectedYear })
            setSelectedCode(null)
            setSelectedGender(null)
            setSelectedYear(null)
        } else {
            setSelectedCode(recoveryData?.selectedCode)
            setSelectedGender(recoveryData?.selectedGender)
            setSelectedYear(recoveryData?.selectedYear)
        }
    }, [checked])

    useEffect(() => {
        if ((postCode || genderIdentity || yearOfBirth) && !checked) {
            setSelectedCode(postCode)
            setSelectedGender(genderIdentity)
            setSelectedYear(yearOfBirth)
        }
    }, [postCode, genderIdentity, yearOfBirth, index])

    useEffect(() => {
        if (checked) {
            dispatch(
                setOnboardingAnswers(
                    {
                        postCode: null,
                        genderIdentity: null,
                        yearOfBirth: null,
                    },
                    'demographic'
                )
            )
            dispatch(activateOnboardingStep({ number: 7, state: false }))
        }
        if (selectedCode && selectedGender && selectedYear) {
            dispatch(
                setOnboardingAnswers(
                    {
                        postCode: selectedCode,
                        genderIdentity: selectedGender,
                        yearOfBirth: selectedYear,
                    },
                    'demographic'
                )
            )
            dispatch(activateOnboardingStep({ number: 7, state: false }))
        }
    }, [checked, selectedCode, selectedYear, selectedGender])

    useEffect(() => {
        if (!checked && !selectedCode && !selectedGender && !selectedYear) {
            dispatch(activateOnboardingStep({ number: 7, state: true }))
        }
    }, [checked, selectedCode, selectedYear, selectedGender])

    return (
        <div>
            <GenderPicker checked={checked} selectedGender={selectedGender} setSelectedGender={setSelectedGender} setChecked={setChecked} />
            <YearOfBirth checked={checked} selectedYear={selectedYear} setSelectedYear={setSelectedYear} setChecked={setChecked} />
            <PostCode checked={checked} selectedCode={selectedCode} setSelectedCode={setSelectedCode} setChecked={setChecked} />
            <DataPrivacySwitch checked={checked} setChecked={setChecked} />
        </div>
    )
}

export default Demographics
